import { ClientError } from '@common/helpers/errors';

// The jobs.actions.create BFF procedure was decommissioned along with
// je-client / je-job-service. This hook is retained as an inert stub so
// obsolete job-post UI still compiles; creating a job is no longer wired to a
// backend.
export type CreateJobParams = any;

export const useCreateJob = () => {
  const mutateAsync = (_params?: CreateJobParams): Promise<any> =>
    Promise.resolve(undefined);
  const error = null as any;
  const isSuccess = false;

  return {
    createJobAsync: mutateAsync,
    error: getClientError(error),
    isSuccess
  };
};

const getClientError = (errorProperties) => {
  if (!errorProperties) return;

  return new ClientError('errors.defaultWithGuid', {
    guid: errorProperties.guid,
    responseBody: errorProperties.responseBody
  });
};
